__turbopack_context__.v({
  "banner": "MfaGate-module__wJ-8NW__banner",
  "bannerBody": "MfaGate-module__wJ-8NW__bannerBody",
  "bannerIcon": "MfaGate-module__wJ-8NW__bannerIcon",
  "bannerLink": "MfaGate-module__wJ-8NW__bannerLink",
  "bannerText": "MfaGate-module__wJ-8NW__bannerText",
  "bannerTitle": "MfaGate-module__wJ-8NW__bannerTitle",
});
